import $ from 'jquery';
import { $Win } from '../utils/jQueryGlobals';
import { gsapSingleton, scrollTriggerSingleton } from '../gsap';

const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();

export default class Context {
  /**
   * Il costruttore ora separa la logica in due parti:
   * 1. initOnce(): Funzionalità globali da eseguire una sola volta.
   * 2. initComponentsAndPageLogic(): Funzionalità legate al contenuto, da rieseguire ad ogni cambio pagina.
   */
  constructor(options = {}) {
    this.initOnce();
    this.initComponentsAndPageLogic();
  }

  initOnce() {
    document.documentElement.classList.remove('no-js');
    this.initMouseCoords();
    this.initScrollEvent();

    this.mainMenuInstance = null;
  }


  initComponentsAndPageLogic() {
    this.loadComponents();

    $(() => {
      $('.rte table').wrap('<div class="responsive-table" />');
    });
  }

  /**
   * Metodo pubblico chiamato da App.js sull'hook 'content:replace' di Swup.
   * Si occupa di preparare e reinizializzare la nuova pagina.
   */
  reinit() {
    this.initComponentsAndPageLogic();

    // Reinizializza il MainMenu per aggiornare gli stili in base al nuovo body class
    if (this.mainMenuInstance && typeof this.mainMenuInstance.reinit === 'function') {
      this.mainMenuInstance.reinit();
    }
  }



  /**
   * Aggiunge un event listener ottimizzato usando requestAnimationFrame
   * per evitare di sovraccaricare il browser.
   */
  addEventListenerFrame(event, callback) {
    let timeout;
    if (typeof event == 'string') {
      event = [event];
    }
    event.forEach((ev) => {
      window.addEventListener(ev, (e) => {
        if (timeout) {
          window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(() => callback(e));
      });
    });
  }

  initScrollEvent() {
    this.addEventListenerFrame(['scroll', 'resize'], () => {
      $Win.trigger('efficient-scroll', document.documentElement.scrollTop);
    });
    $Win.trigger('efficient-scroll', document.documentElement.scrollTop);
  }

  initMouseCoords() {
    this.addEventListenerFrame('mousemove', (e) => {
      document.documentElement.style.setProperty('--mouse-client-x', `${e.clientX}px`);
      document.documentElement.style.setProperty('--mouse-client-y', `${e.clientY}px`);
    });
  }

  /**
   * Carica dinamicamente i componenti presenti nel DOM.
   * La funzione è asincrona per attendere il caricamento dei moduli JS.
   */
  async loadComponents(name = false, context) {
    const selector = name
      ? `[data-g-component="${name}"]`
      : '[data-g-component]';

    const elementsToInitialize = $(selector, context).get().filter(elem => !$(elem).data('g-component-initialized'));

    await Promise.all(elementsToInitialize.map(async (elem) => {
      const $elem = $(elem);
      const componentName = $elem.data('g-component');

      if (componentName) {
        try {
          const module = await import(`../components/${componentName}.js`);
          const ComponentClass = module.default;

          if (typeof ComponentClass === 'function') {
            const instance = new ComponentClass(elem, this);
            $elem.data('g-component-initialized', true);

            // 2. Se il componente è MainMenu, salvalo
            if (componentName === 'MainMenu') {
              this.mainMenuInstance = instance;
            }

          } else {
            console.error(`Il componente "${componentName}" è stato caricato ma non è una classe/funzione valida.`);
          }
        } catch (error) {
          console.error(`Errore durante il caricamento del componente "${componentName}":`, error);
        }
      }
    }));
  }

  getCssVar(name, elem = document.documentElement) {
    return getComputedStyle(elem).getPropertyValue(name);
  }

  getBreakpoint(bp, elem = document.documentElement) {
    let value = this.getCssVar(`--breakpoint-${bp}`, elem);
    if (value) {
      value = parseInt(value);
    }
    return value || 0;
  }
}
